var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component, createRef } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { modalStackSelector, removeModalAction } from '../../redux-module';
import { NotificationsView } from './_components/notifications-view';
var WrappedContainer = /** @class */ (function (_super) {
    __extends(WrappedContainer, _super);
    function WrappedContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notificationModalRef = createRef();
        _this.closeModal = function (id) { return _this.props.removeModal(id); };
        _this.makeExternalAction = function (_a) {
            var id = _a.id, additionalActionType = _a.additionalActionType, additionalPayload = _a.additionalPayload;
            if (additionalActionType) {
                _this.props.dispatch({
                    type: additionalActionType,
                    payload: __assign({ id: id }, additionalPayload),
                });
            }
        };
        return _this;
    }
    WrappedContainer.prototype.render = function () {
        return (React.createElement(NotificationsView, { modalStack: this.props.modalStack, closeModal: this.closeModal, makeExternalAction: this.makeExternalAction, zIndex: this.props.zIndex }));
    };
    return WrappedContainer;
}(Component));
export { WrappedContainer };
var mapStateToProps = function (state) { return ({
    modalStack: modalStackSelector(state),
}); };
var mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        dispatch: dispatch,
        removeModal: removeModalAction,
    }, dispatch);
};
export var Notifications = connect(mapStateToProps, mapDispatchToProps)(WrappedContainer);
